import {useAddNotification} from '@logistics-frontend/blocks'
import {firstOf, get} from '@logistics-frontend/utils'
import {useCallback} from 'react'

import {useI18n} from '../../../i18n'
import {ServerError} from '../fetch'

export const useBaseErrorCatcher = () => {
  const t = useI18n()
  const notify = useAddNotification()

  return useCallback(() => {
    notify(t('request.mutation.error'), {type: 'error'})
  }, [t, notify])
}

export const useErrorCatcher = (getErrorText: (error: ServerError) => string | undefined) => {
  const t = useI18n()
  const notify = useAddNotification()

  return useCallback(
    (error: ServerError) => {
      const getMessage = firstOf(getErrorText, get('message'))

      notify(getMessage(error) || t('request.mutation.error'), {
        type: 'error',
        xYaTraceId: get('headers.x-yatraceid', error),
      })
    },
    [t, notify, getErrorText],
  )
}
